import React from 'react'

const InfoNotificationBlue = () => (
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 13.5C10.575 13.5 13.5 10.575 13.5 7C13.5 3.425 10.575 0.5 7 0.5C3.425 0.5 0.5 3.425 0.5 7C0.5 10.575 3.425 13.5 7 13.5ZM7 1.42857C10.0643 1.42857 12.5714 3.93571 12.5714 7C12.5714 10.0643 10.0643 12.5714 7 12.5714C3.93571 12.5714 1.42857 10.0643 1.42857 7C1.42857 3.93571 3.93571 1.42857 7 1.42857Z"
            fill="#0559BF"
        />
        <path
            d="M12.5714 6.9999C12.5714 3.93561 10.0643 1.42847 7.00002 1.42847C3.93573 1.42847 1.42859 3.93561 1.42859 6.9999C1.42859 10.0642 3.93573 12.5713 7.00002 12.5713C10.0643 12.5713 12.5714 10.0642 12.5714 6.9999Z"
            fill="white"
        />
        <path
            d="M7.46426 9.32146H8.39283V10.25H5.60712V9.32146H6.53569V6.53575H5.60712V5.60718H7.46426V9.32146Z"
            fill="#0559BF"
        />
        <path
            d="M7.00002 4.6785C7.37145 4.6785 7.69645 4.3535 7.69645 3.98207C7.69645 3.61064 7.37145 3.28564 7.00002 3.28564C6.62859 3.28564 6.30359 3.61064 6.30359 3.98207C6.30359 4.3535 6.62859 4.6785 7.00002 4.6785Z"
            fill="#0559BF"
        />
    </svg>
)

export default InfoNotificationBlue
